import React from 'react';
import PropTypes from 'prop-types';
import { MaterialIcon } from '@pearsontechnology/aero-components';

import { NavBackIconLink } from './styles';

const NavBackButton = ({ backTo }) => (
  <NavBackIconLink to={backTo}>
    <MaterialIcon id="keyboard_arrow_left" color={'#FFFFFF'} />
  </NavBackIconLink>
);

NavBackButton.propTypes = {
  backTo: PropTypes.string,
};

export default NavBackButton;
